import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { MySwal } from "./alerts.tsx";

const DOMAIN = "https://server.lukiao.com.co";

export const requestSquematic = async (
  type: "GET" | "POST" | "DELETE" | "PUT",
  url: string,
  object: any,
  token?: string,
  onTokenError?: () => void,
  cancelToken?: AbortSignal
): Promise<any> => {
  try {
    let res: AxiosResponse<any>;
    const generalParams: AxiosRequestConfig<any> = {
      headers: { Authorization: `Bearer ${token}` },
      signal: cancelToken,
    };

    if (type === "GET") {
      res = await axios.get(DOMAIN + url, {
        ...generalParams,
        params: object,
      });
    } else {
      res = await axios.post(DOMAIN + url, object, generalParams);
    }

    const data = res.data;

    if (data.status === "OK") {
      return data;
    } else {
      !MySwal.isVisible() &&
        MySwal.fire({
          icon: "error",
          title: "¡Error!",
          text: "Typing problem...",
          footer: errorHandler(data.errors),
        });
    }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const err: AxiosError = error;

      if (err.response?.status === 401) {
        onTokenError?.();
        !MySwal.isVisible() &&
          MySwal.fire({
            icon: "error",
            title: "¡Error!",
            text: "Problema de sesión...",
            footer: "Tu sesión ha caducado, vuelve a iniciar...",
          });

        return;
      }
    } else if (error instanceof TypeError) {
      !MySwal.isVisible() &&
        MySwal.fire({
          icon: "error",
          title: "¡Error!",
          text: "Typing problem...",
          footer: error.message,
        });

      return;
    } else if (axios.isCancel(error)) {
      return;
    }

    !MySwal.isVisible() &&
      MySwal.fire({
        icon: "error",
        title: "¡Error!",
        text: "Server problem...",
        footer: error,
      });
  }
};

export const errorHandler = (errors: string | any): string => {
  if (typeof errors === "string") {
    return errors;
  }

  const errs: string[] = [];

  Object.keys(errors).forEach((key) =>
    errs.push(...errors[key as keyof object])
  );

  return errs.join("\n\n");
};

// Formatear un número y agregar puntos como separadores de miles.
export const formatNumberPoint = (num: number | string): string => {
  let numTemp = parseInt(num + "");
  return numTemp.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};
